export const MATERIAL_CHANGE = 'material-change';// 素材变更
export const MAP_CHANGE = 'map-change'; // 画布变更
export const MATERIAL_FILTER_IMAGE = 'filter_image'; // 滤镜变更
export const OPEN_LOGIN = 'open-login-dialog'; // 拉起登录框
export const REFRESH_LOGIN = 'refresh-login'; // 刷新登录
export const SAVE_SCENT = 'save-scent'; // 保存场景
export const SAVE_SCENT_DETAIL = 'save-scene-detail'; // 保存场景详细信息
export const MAP_SAVE = 'map_save'; // 保存画布
export const REFRESH_STORYLINE = 'refresh_storyline';
export const CHANGE_JUMP = 'change_jump'; // 故事线更新跳转节点
export const SAVE_MISSION = 'save-mission'; // 保存剧情详细信息
export const SAVE_MISSION_DETAIL = 'save-mission-detail';
